import React from 'react';
import Row from 'components/Row';
import Col from 'components/Col';
import { AvatarName } from '../styled';
import Avatar from 'components/Avatar';
import { Typography } from '@material-ui/core';
import * as moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/CancelOutlined';
import { Button } from '@material-ui/core';
import DownIcon from '@material-ui/icons/ThumbDown';
import UpIcon from '@material-ui/icons/ThumbUp';
import color from 'config/color';

export default function Comment({
  comment,
  uid,
  likePostComment,
  deletePostComment,
  startEditing,
  onClick,
  authUser
}) {
  let liked = false;
  if (comment.upVotes) {
    liked = comment.upVotes.includes(uid);
  }

  const handleOnClick = () => {
    if (!authUser.anon) {
      likePostComment(comment, uid);
    } else {
      onClick();
    }
  };
  return (
    <Row>
      <div>
        <Avatar
          marginright="0"
          width="40px"
          height="40px"
          image={comment.imageURL}
        />
      </div>
      <Col padding="0" style={{ width: '100%', marginLeft: '1em' }}>
        <Row
          style={{
            justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <AvatarName>{comment.name}</AvatarName>
            <Typography
              variant="body2"
              style={{
                lineHeight: 1,
                fontSize: 14,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {moment(comment.date).fromNow()}
            </Typography>
          </div>
          {uid === comment.uid && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <EditIcon
                style={{ fontSize: 12, cursor: 'pointer', marginRight: 10 }}
                onClick={() => startEditing(true)}
              />
              <DeleteIcon
                style={{ fontSize: 12, cursor: 'pointer', marginRight: 5 }}
                onClick={() => deletePostComment(comment)}
              />
            </div>
          )}
        </Row>
        <Row style={{ justifyContent: 'space-between', width: '100%' }}>
          <Typography style={{ color: color.grey, fontSize: 20 }}>
            {comment.message}
          </Typography>
        </Row>
        <Row marginbottom="0">
          <Button color="primary" onClick={handleOnClick}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {liked ? (
                <>
                  <DownIcon style={{ marginRight: 8, fontSize: 12 }} />
                  <div
                    style={{ fontSize: 8, height: '100%', lineHeight: '12px' }}
                  >
                    Unlike
                  </div>
                </>
              ) : (
                <>
                  <UpIcon style={{ marginRight: 8, fontSize: 12 }} />
                  <div
                    style={{ fontSize: 8, height: '100%', lineHeight: '12px' }}
                  >
                    Like
                  </div>
                </>
              )}
            </div>
          </Button>
          <div
            style={{
              fontSize: 12,
              lineHeight: '12px',
              padding: 5,
              textTransform: 'none'
            }}
          >{`${comment.upVotes ? comment.upVotes.length : 0} likes`}</div>
        </Row>
      </Col>
      <br />
    </Row>
  );
}
